var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1B1230"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.45,
    d: "M6.943 17.443L14.75 6.579c.369-.652 1.783-.493 2.375-.262l-7.659 10.65c-.313.493-1.86.527-2.529.472z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.827 10.929c.424.013.788.63.788 1.071c0 .442-.364 1.059-.788 1.072H10.73c-2.014-.026-3.87-2.023-3.87-4.076c0-2.057 1.856-3.827 3.87-3.853h5.404c.425.013 1.007.369 1.007 1.05c0 .677-.355 1.071-1.007 1.093H10.73A1.753 1.753 0 0 0 9 8.996c0 1.157.591 1.933 1.731 1.933h2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.173 13.072c-.425-.013-.789-.63-.789-1.072c0-.441.364-1.058.788-1.071h2.096c2.015.025 3.874 2.023 3.874 4.076c0 2.057-1.86 3.827-3.874 3.852H7.864c-.63-.017-.99-.342-1.007-1.032a1.084 1.084 0 0 1 1.007-1.11h5.404c.9 0 1.732-.686 1.732-1.71c0-1.158-.592-1.933-1.732-1.933z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnx);
export default __webpack_public_path__ + "static/media/snx.6eff64874e943ff66738d3bc0c3adbfa.svg";
export { ForwardRef as ReactComponent };